import React from 'react';
import FlowLayout from '../../../components/layout/FlowLayout';
import { FLOWS_ENUM } from '../../../common/enums';
import { useSelector } from 'react-redux';
import { selectConfigExpressTaxCertificateSuccess } from '../../../store/slices/config/configSelectors';
import usePlaceNavigate from '../../../hooks/usePlaceNavigate';
import { constructMarkup } from '../../../common/utils';

const TaxCertSuccess = () => {
  const placeNavigate = usePlaceNavigate();
  const successConfig = useSelector(selectConfigExpressTaxCertificateSuccess);

  return (
    <FlowLayout
      flow={FLOWS_ENUM.TAX_CERTIFICATE}
      title={successConfig?.title ?? 'Your Tax Certificate is Ready'}
      additionalButton={{
        label: 'Return to Dashboard',
        onClick: () => placeNavigate('/dashboard'),
        className: 'btn-secondary',
      }}
    >
      {successConfig?.text && <div>{constructMarkup(successConfig.text)}</div>}
    </FlowLayout>
  );
};

export default TaxCertSuccess;
